export const MAX_ASPECT_RATIO_APP = 10;
export const MIN_ASPECT_RATIO_APP = 1/MAX_ASPECT_RATIO_APP;
export const MAX_ASPECT_RATIO_WEB = 10;
export const MIN_ASPECT_RATIO_WEB = 1/MAX_ASPECT_RATIO_WEB;


export const savedPresets = [{

  title: "Square [Mobile - 1, Web - 1]",
  id: "square-presets",
  values: {ar: 1, ar_web: 1, rows: 3, rows_web: 3, show_title: true, hf: 1, hf_web: 1}
}, {
  title: "Mostly Used [Mobile - 2.5, Web - 3]",
  id: "used-presets",
  values: {ar: 2.5, ar_web: 3, rows: 2, rows_web: 3, show_title: true, hf: 1, hf_web: 1}
}];


export const savedBannerPresets = [{
  title: "Default Banner",
  id: "default-presets",
  values: {ar: 1.98, ar_web: 3.73}
}, {
  title: "Small Banner",
  id: "square-presets",
  values: {ar: 3, ar_web: 5}

}];



